import React from 'react';

function ProgressBanner({
  user,
  collapsedStat,
  autoRotateStats,
  progressExpanded,
  renderCollapsedProgress,
  onOpen,
  onClose,
  onSetCollapsedStat,
  onToggleAutoRotate,
}) {
  return (
    <>
      <div className="progress-summary">
        <button
          type="button"
          className="progress-compact"
          onClick={onOpen}
        >
          {renderCollapsedProgress()}
          <span className="progress-hint">Tap to expand</span>
        </button>
      </div>

      {progressExpanded && (
        <div className="progress-overlay" onClick={onClose}>
          <div className="progress-modal" onClick={(event) => event.stopPropagation()}>
            <div className="progress-header">
              <h2>Progress Overview</h2>
              <button className="close-btn" onClick={onClose}>✕</button>
            </div>
            <div className="progress-controls">
              <span>Progress Banner</span>
              <div className="progress-options">
                {['streak', 'xp', 'level'].map((option) => (
                  <button
                    key={option}
                    type="button"
                    className={`progress-option ${collapsedStat === option ? 'active' : ''}`}
                    onClick={() => {
                      onSetCollapsedStat(option);
                      onToggleAutoRotate(false);
                    }}
                  >
                    {option === 'streak' && 'Streak'}
                    {option === 'xp' && 'XP'}
                    {option === 'level' && 'Level'}
                  </button>
                ))}
              </div>
              <div className="progress-toggle">
                <span>Cycle Progress Banner</span>
                <button
                  type="button"
                  className={`toggle-pill ${autoRotateStats ? 'on' : ''}`}
                  onClick={() => onToggleAutoRotate(!autoRotateStats)}
                  aria-pressed={autoRotateStats}
                >
                  <span className="toggle-indicator" />
                </button>
              </div>
            </div>
            <div className="progress-grid">
              <div className="progress-card">
                <span className="progress-card-label">Level</span>
                <span className="progress-card-value">{user.level}</span>
              </div>
              <div className="progress-card">
                <span className="progress-card-label">XP</span>
                <span className="progress-card-value">{user.xp} / {user.getXPForNextLevel()}</span>
                <div className="progress-bar">
                  <div
                    className="progress-bar-fill"
                    style={{ width: `${(user.xp / user.getXPForNextLevel()) * 100}%` }}
                  />
                </div>
              </div>
              <div className="progress-card">
                <span className="progress-card-label">Streak</span>
                <span className="progress-card-value">🔥 {user.streakDays} days</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProgressBanner;
